module.exports = __webpack_public_path__ + "lights.png";